
import client from '../client';
import qs from "qs";


export const dataProfile = () => {
    return client.post(`/service/profile`)
}
